import combineActionHandlers from "@web-monorepo/infra/combineActionHandlers";
import { InstallReducer } from "@web-monorepo/shared/podInfra";
import createKeducer from "./createKeducer";

export default function createToolPod(STATE_KEY: string, customActionKey: string) {
  customActionKey = customActionKey || `${STATE_KEY}_ACTION`.toUpperCase();
  const { action, reducerHandler } = createKeducer(customActionKey);

  function install(installReducer: InstallReducer) {
    const reducer = combineActionHandlers({}, [reducerHandler]);
    installReducer(STATE_KEY, reducer);
  }

  return { install, action };
}
